module.exports = __webpack_public_path__ + "img/blue-file.10682c96.svg";